/*
* @Author: babysoft08
* @Date:   2025-08-23 00:03:02
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-08-23 00:42:22
*/
import React from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import StaticPagesService from './../../services/StaticPagesService/StaticPagesService';
import ContactService from './../../services/ContactService/ContactService';
import GearSpinner from '../../components/GearSpinner/GearSpinner';

const renderHTML = (rawHTML: string) =>
  React.createElement("div", {
    className: "row",
    dangerouslySetInnerHTML: { __html: rawHTML },
  });

const renderHTMLV2 = (rawHTML: string) =>
React.createElement("p", {
  dangerouslySetInnerHTML: { __html: rawHTML },
});

class RepPortal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data:[],
			is_loader: true
		}
		this.staticPagesService = new StaticPagesService();
	}

	componentDidMount() {
		this.getPageData();
	}

	getPageData() {
		const permalink = 'repportal';
		this.staticPagesService.getStaticPage(permalink).then(response=>{
			this.setState({is_loader : false});
			if(response.status===200) {
				this.setState({data:response.data.result.static_page[0].fields})
			}
		});
	}

	render() {
		let { data } = this.state;
		let { is_loader } = this.state
		return (
	      <React.Fragment>
	        <main role="main" className="middle-content-area">
	          <section className="tracking-section">
	            <div className="container">
	              <div className="row">
	                <div className="col-md-12">
	                  <div className="default-title">
	                    <div className="row">
	                      <div className="col-md-6">  
	                        <h1 className="m-0 color1"> Repportal</h1>
	                      </div>
	                    </div>
	                  </div>
	                  <div className="row">
	                    <div className="col-md-12">
	                        {is_loader ? (
	                        <GearSpinner />
	                      ) : (
	                        (data.content && renderHTML(data.content)) || ''
	                      )}
	                    </div>  
	                  </div>
	                </div>  
	              </div>
	            </div>
	          </section>
	        </main>
	      </React.Fragment>
	    );
	}

}

export default RepPortal;